export default __webpack_public_path__ + "img/3383e1b35fb3b2e6a647066fcd0928d0.svg";